
"use client";

import Timeline from "@/components/Visitors/Timeline";
import React from "react";

const TimelinePage = () => {
    return <Timeline />;
};

export default TimelinePage;
